export default __webpack_public_path__ + "static/Robert Skinner_flags_social-92fdfda893790171874f50e6ce54e542.jpg";